import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as rolesActions from 'modules/roles/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$
    .ofType(constAction.ROLES_GET_ALL)
    .debounceTime(1000)
    .switchMap(action =>
      ajax(request(action))
        .map(result => rolesActions.setState({ lista: result.response }))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.ROLES_SET)
    .debounceTime(1000)
    .switchMap(action =>
      ajax(request(action))
        .map(() => push('/dashboard/roles/'))
        .concat(Rx.Observable.of(generalActions.snackbar_show('Roles guardados')))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getUserRolesEpic = (action$, store) =>
  action$
    .ofType(constAction.ROLES_GET_USER)
    .debounceTime(1000)
    .switchMap(action =>
      ajax(request(action)) //TODO
        .map(result => rolesActions.setState({ rolesUser: result.response }))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, setEpic, getUserRolesEpic);



// WEBPACK FOOTER //
// src/modules/roles/epics.js